// The page numbers a pager shows: the first and last page, the current page and
// its neighbours, with null standing in for each collapsed run of pages. A gap
// of one page is shown as that page, since an ellipsis would take the same room.
export const pageWindow = (page, pageCount) => {
  const shown = new Set([1, pageCount, page - 1, page, page + 1])
  const pages = [...shown].filter(n => n >= 1 && n <= pageCount).sort((a, b) => a - b)

  return pages.reduce((window, n, index) => {
    const gap = index === 0 ? 0 : n - pages[index - 1] - 1
    if (gap === 1) window.push(n - 1)
    if (gap > 1) window.push(null)
    window.push(n)
    return window
  }, [])
}
